import { getLastEnrolledCompanyPolicy } from "EmployerDashboard/utils";

import { RECEIVE_EMPLOYER_DATA, UPDATE_MANAGE_EMPLOYEES_TAB, UPDATE_OFFER_COVERAGE_SUCCESS_MESSAGE } from "./actions";

import type { Action, SiteConfig } from "./store";

export const companyPolicyId = (state: string = "", action: Action): string => {
  if (action.type === RECEIVE_EMPLOYER_DATA) {
    const policy = getLastEnrolledCompanyPolicy(action.payload);
    return policy.id || state;
  }
  return state;
};

export const companyProfileId = (state: string = "", action: Action): string => {
  if (action.type === RECEIVE_EMPLOYER_DATA) {
    const policy = getLastEnrolledCompanyPolicy(action.payload);
    return policy.companyProfile.id || state;
  }
  return state;
};

export const accountId = (state: string = "", action: Action): string => {
  if (action.type === RECEIVE_EMPLOYER_DATA) {
    return action.payload.id || state;
  }
  return state;
};

export const siteConfig = (state: SiteConfig = {}, action: Action): SiteConfig => {
  if (action.type === RECEIVE_EMPLOYER_DATA) {
    return action.payload.siteConfig || state;
  }
  return state;
};

export const manageEmployeesTab = (state: string = "Active", action: Action): string => {
  if (action.type === UPDATE_MANAGE_EMPLOYEES_TAB) {
    return action.payload || state;
  }
  return state;
};

export const offerCoverageSuccessMessage = (state: string = "", action: Action): string => {
  if (action.type === UPDATE_OFFER_COVERAGE_SUCCESS_MESSAGE) {
    return action.payload || "";
  }
  return state;
};
